import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "@reach/router";
import { BasicLayout } from "layouts";
import { FormInput, FormCheckbox, Button } from "components";
import { navigate } from "@reach/router";
import { ReactSpinner } from "react-spinning-wheel";
import "react-spinning-wheel/dist/style.css";
import { useAuthContext } from "contexts/Auth";
import { useNotifications } from 'reapop';
import {
  login as loginApi,
  getPermissions,
  getAcquiaToken,
  getConfig,
} from "api";
import "./style.scss";

export const LoginPage: React.FC<RouteComponentProps> = () => {
  const { isLogined, currentPage, setProfile } = useAuthContext();
  const [currentIndex, setCurrentIndex] = useState<number>(-1);
  const [name, setName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { notify } = useNotifications();
  useEffect(() => {
    if (isLogined) {
      navigate(currentPage);
    }
    return () => { };
  }, [isLogined]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsSubmit(true);
    if (name != "" && password != "") {
      setLoading(true);
      try {
        let res: any = await loginApi(name, password);
        const user = res.data.user;
        ////Privacy Preferences Admin - Begin
        localStorage.setItem("user_details",  JSON.stringify(user));
        ////Privacy Preferences Admin - End
        const bearerToken = res.data.token;
        localStorage.setItem("bearerToken", `Bearer ${bearerToken}`);
        if (!user.sec_groups) {
          return;
        }
        try {
          res = await getPermissions(user.sec_groups);
          const permissions = res.data;
          ////Privacy Preferences Admin - Begin
          localStorage.setItem("user_permissions",  JSON.stringify(permissions));
          ////Privacy Preferences Admin - End
          try {
            if (!permissions["sec_permissions"].includes("Login")) {
              throw false;
            }  
          } catch (error: any) {
            setLoading(false);
              notify('You do not have permission to access this portal.', 'error', {
                title: 'Permission denied'
              });
              return;
          }

          await setProfile({ ...user, ...permissions });
          try {
            let token: any = await getAcquiaToken();
            localStorage.setItem("tenantId", token.data.tenantId);
            localStorage.setItem("token", token.data.token);
          } catch (error: any) {
            console.log("token error", error);
          }
          try {
            let config: any = await getConfig();
            localStorage.setItem("config", JSON.stringify(config.data));
          } catch (error: any) {
            console.log("config error", error);
          }
          setLoading(false);
          navigate("/dashboard");
        } catch (error: any) {
          console.log("permission error", error);
        }
      } catch (error: any) {
        setLoading(false);
        notify('Username or password is not correct.', 'error', {
          title: 'Authentication failed'
        });
        console.log("login error", error);
      }
    }
  };

  const clicableClass = loading ? "none" : "auto";

  return (
    <BasicLayout>
      <form className="login-page-container mt-auto" onSubmit={handleSubmit} style={{ opacity: loading ? 0.5 : 1, pointerEvents: clicableClass }}>
        <span className="login-page-title">Login</span>
        <FormInput
          id={0}
          mt={0}
          type="text"
          label="Input name"
          isSubmit={isSubmit}
          firstInput={name}
          index={currentIndex}
          error="Name is empty"
          setIndex={() => setCurrentIndex(0)}
          updateFirstInput={(val) => setName(val)}
        />
        <FormInput
          id={1}
          mt={20}
          isSubmit={isSubmit}
          type="password"
          label="Password"
          secondInput={password}
          index={currentIndex}
          error="Password is empty"
          setIndex={() => setCurrentIndex(1)}
          updateSecondInput={(val) => setPassword(val)}
        />
        <FormCheckbox />
        <Button>Login</Button>
        <a href="https://passwordreset.microsoftonline.com" className="forgot-password-text">
          Forgot Password?
        </a>
      </form>
      {loading && (
        <div className="loading-spinner">
          <ReactSpinner />
        </div>
      )}
    </BasicLayout>
  );
};
